import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { selectWork, selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { HBox, VBox } from '../../../../components/Box';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { selectVehicle } from '../../../Vehicles/selectors';
import { Cell as ActionCell } from '../Cell';
import { finalizeAndExportInvoice } from '../../../Invoices/actions';
import { VehicleHeaderV2Design } from '../../../Vehicles/components/VehicleHeaderV2Design';
import { FINCompanyCard } from '../../../Companies/components/FinCompanyCard';
import { selectCompany } from '../../../Companies/selectors';
import { REQUEST_COMPANY, REQUEST_VIES_CHECK } from '../../../Companies/constants';
import { checkVies } from '../../../Companies/actions';
import { FINALIZE_EXPORT_MAIL_INVOICE } from '../../../Invoices/constants';
import { ViesCheckPrompt } from '../../../Invoices/components/ViesCheckPrompt';
import { toggleKanbanCompanyModal } from '../../actions';
import { selectKanbanCompanyToggle } from '../../selectors';
import { SideModal } from '../../components/SideModal';
import { InvoiceFinalizationSection } from '../../components/InvoiceFinalizationSection';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import cn from 'classnames';
import styles from './HOOI.module.css';

const Container = styled.div`
  h2 {
    font-size: 16px;
    text-transform: uppercase;
  }

  .pane {
    padding: 24px 12px;

    .fields {
      margin-top: 24px;
    }

    h3 {
      margin-bottom: 12px;
    }

    h4 {
      margin-top: 24px;
      font-size: 20px;
    }
  }
`;

const STATE = {
  approve: false,
  showViesCheckPrompt: false,
};

/* eslint-disable react/prefer-stateless-function */
class HOOI_factureren_Comp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  resetPrompt() {
    this.setState({ showViesCheckPrompt: false });
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  toggle() {
    return this.props.toggleModal(this.vehicle?.id);
  }

  onViesCheck(invoiceId) {
    const dto = {
      id: +this.vehicle?.invoice_outgoing_company_id,
      entity: 'company',
      countryCode: this.props.company?.BTW_number?.substring(0, 2),
      vatCode: this.props.company?.BTW_number?.substring(2),
    };

    this.props.checkViesStatus(dto, result => {
      if (result?.valid) {
        this.finalize(invoiceId);
        return;
      }

      this.setState({ showViesCheckPrompt: true });
    });
  }

  finalize(invoiceId) {
    this.setState({ showViesCheckPrompt: false });

    return this.props.finalizeAndExport(invoiceId, 'outgoing', 'ignored_email@gmail.com', result => {});
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <ActionCell className={styles.cell}>
        <Container>
          {this.props.isShowModal?.isShow && this.props.isShowModal?.entityId == vehicle?.id && (
            <SideModal className={styles.sideContainer}>
              <div className={styles.buttonClose}>
                <button
                  onClick={this.toggle.bind(this)}
                  type="button"
                  className={cn('btn-close', styles.buttonCl)}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <WithVehicle vehicle_id={this.vehicle.id} loader>
                <VBox>
                  {this.state.showViesCheckPrompt && (
                    <ViesCheckPrompt
                      onConfirm={() => this.finalize(this.vehicle?.outgoing_invoice)}
                      onCancel={this.resetPrompt.bind(this)}
                    />
                  )}
                  <h2>{this.props.action?.functionName}</h2>

                  <div className={styles.boxButtons}>
                    <ButtonComponent
                        style={'ButtonSoftPrimary'} onClick={this.tofn(`/invoices/${this.vehicle.outgoing_invoice}`)}>
                      <View /> {this.lbl('vehicle.details.view_outgoingInvoice')}
                    </ButtonComponent>
                    <InvoiceFinalizationSection className={styles.buttonInvoiceFinalizationSection} invoice_id={this.vehicle?.outgoing_invoice} />
                  </div>

                  <VehicleHeaderV2Design wide vehicle={this.vehicle} />
                  <FINCompanyCard companyId={this.vehicle?.invoice_outgoing_company_id} />
                </VBox>
                <div className="pane"></div>
              </WithVehicle>
            </SideModal>
          )}
          <VehicleHeader vehicle={vehicle} />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <div className={styles.cellButtonContainer}>
                <CellButton onClick={this.toggle.bind(this)}>
                  <View />
                </CellButton>
              </div>
            )}
          </CellButtons>
        </Container>
      </ActionCell>
    );
  }
}

HOOI_factureren_Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`]),
    workCompany: selectWork(REQUEST_COMPANY),
    workFinalizeAndExport: selectWork(FINALIZE_EXPORT_MAIL_INVOICE),
    workViesCheck: selectWork(REQUEST_VIES_CHECK),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    company: selectCompany(ownProps.cell.vehicle?.invoice_outgoing_company_id),
    isShowModal: selectKanbanCompanyToggle(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    finalizeAndExport(invoiceId, direction, email_address, callback) {
      dispatch(finalizeAndExportInvoice(invoiceId, direction, email_address, callback));
    },
    checkViesStatus(dto, callback) {
      dispatch(checkVies(dto, callback));
    },
    toggleModal(vehicleId) {
      dispatch(toggleKanbanCompanyModal(vehicleId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HOOI_factureren = compose(withConnect, withRouter)(HOOI_factureren_Comp);
